import { app } from '../../../bootstrap/core';
import loadingOverlayComponent from './loadingOverlay.component';

app.component('loadingOverlay', loadingOverlayComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/loadingOverlay/loadingOverlay.js